export const HIERARCHICAL_SEPARATOR = '--'
